import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  ACCEPTED_DOCUMENT_TYPES,
  ACCEPTED_FILE_TYPES,
  FilesModel,
  IFileModel,
  TabItem,
} from '@sml/utility';
import { TAB_SECTION } from './item-upload.constant';
import { MediaUploaderComponent } from '@sml/media-uploader';
import { TabsComponent } from '@sml/tabs';
import { IconsComponent } from '@sml/icons';
import { ButtonsModule } from '@sml/buttons';

@Component({
  selector: 'sml-item-upload',
  standalone: true,
  imports: [CommonModule, MediaUploaderComponent, TabsComponent,IconsComponent,ButtonsModule],
  templateUrl: './item-upload.component.html',
})
export class ItemUploadComponent implements OnChanges {
  @Input() heading = '';
  @Input() subHeading = '';
  @Input() galleryBlob = '[]';
  @Input() documentBlob = '[]';
  @Output() uploadedFiles = new EventEmitter<FilesModel>();
  activeTab = "photoGallery";
  isDocumentVisible=false;
  switchTab = false;
  mediaFiles: IFileModel[] = [];
  galleryFiles: IFileModel[] = [];
  documentFiles: IFileModel[] = [];
  galleryFilesFinal: IFileModel[] = [];
  documentFilesFinal: IFileModel[] = [];
  tabSectionStrings = TAB_SECTION;
  sections: TabItem[] = [
    {
      key: this.tabSectionStrings.PHOTO_GALLERY,
      title: 'Photo Gallery',
      mediaLength: 0,
    },
    {
      key: this.tabSectionStrings.ITEM_DOCUMENTS,
      title: 'Item Documents',
      mediaLength: 0,
    },
  ];
  allowedFileTypes = ACCEPTED_FILE_TYPES;
  allowedDocumentsTypes = ACCEPTED_DOCUMENT_TYPES;

  ngOnChanges(): void {
    this.galleryFiles = JSON.parse(
      this.galleryBlob || '[]',
    );
    this.documentFiles = JSON.parse(
      this.documentBlob || '[]',
    );

    this.galleryFilesFinal = [...this.galleryFiles];
    this.documentFilesFinal = [...this.documentFiles];
    this.isDocumentVisible = this.documentFilesFinal.length > 0;

    this.uploadedFiles.emit({
      galleryFiles: this.galleryFilesFinal,
      documentFiles: this.documentFilesFinal,
    });
  }

  activeTabChange(currentTab: string): void {
    this.activeTab = currentTab;
  }
  allowTabSwitch(value:boolean): void {
    this.switchTab = value;
  }

  onFilesChanged(files: FilesModel): void {
    // Always preserve existing data when one type is undefined
    if (files.galleryFiles !== undefined) {
      this.galleryFilesFinal = files.galleryFiles;
      this.galleryFiles = files.galleryFiles;
    }
    if (files.documentFiles !== undefined) {
      this.documentFilesFinal = files.documentFiles;
      this.documentFiles = files.documentFiles;
    }

    // Always emit both arrays to preserve data integrity
    this.uploadedFiles.emit({
      galleryFiles: this.galleryFilesFinal,
      documentFiles: this.documentFilesFinal
    });
  }

  galleryFilesLength(galleryMediaLength: number): void {
    const gallerySection = this.sections.find(
      (section) => section.key === this.tabSectionStrings.PHOTO_GALLERY,
    );
    if (gallerySection) {
      gallerySection.mediaLength = galleryMediaLength;
    }
  }

  documentFilesLength(documentMediaLength: number): void {
    const documentSection = this.sections.find(
      (section) => section.key === this.tabSectionStrings.ITEM_DOCUMENTS,
    );
    if (documentSection) {
      documentSection.mediaLength = documentMediaLength;
    }
  }

  removeDocuments(){
    this.isDocumentVisible = false;
    this.documentFiles = [];
    this.documentFilesFinal = [];
    this.uploadedFiles.emit({
      galleryFiles: this.galleryFilesFinal,
      documentFiles: this.documentFilesFinal,
    });
  }
}
